const SelfcareOfferCard = ({
  offer,
  isModal,
  index,
  offerIndex,
  handleSelect,
}) => {
  return (
    <div
      className={`${
        !isModal
          ? "border border-1 border-gray rounded-1 p-3 h-100 d-flex flex-column justify-content-between"
          : ""
      }`}
    >
      {!isModal ? (
        <div className="d-flex justify-content-between align-items-center py-2">
          <h3
            className="fs-5 text-black fw-bold mb-0 truncate-single-line"
            title={offer.title}
          >
            {offer.title}
          </h3>
          {!offer.isCurrentPlan ? (
            <button
              className="rv-subscription-btn rounded-1 border-0 px-3"
              onClick={() => {
                handleSelect(offer, offerIndex, index);
                // openSubscriptionModal(index, offerIndex);
              }}
            >
              Select
            </button>
          ) : (
            <p className="rv-subscription-currentPlan-Label rounded-1 text-center px-2 mb-0">
              Current Plan
            </p>
          )}
        </div>
      ) : null}
      <div className="py-3">
        <span className="fs-5  text-wrap  w-100 text-break">
          <span className="rv-offer-code p-2 d-inline-block rounded-2 fw-bold">
            {offer.offerCode.toUpperCase()}
          </span>
        </span>
      </div>
      <div className="py-3">
        <div className="d-flex align-items-center">
          <span
            className="rv-primary-background-color p-1 rounded-circle d-flex align-items-center justify-content-center"
            style={{ width: "32px", height: "32px" }}
          >
            <i class="ri-calendar-2-line rv-text-primary-color"></i>
          </span>
          <div className="px-2">
            <h4 className="fs-14 mb-0 rv-text-label-color">Validity</h4>
            <h4 class="mb-0 fs-14 fw-semibold text-black">{offer.validity}</h4>
          </div>
        </div>
      </div>
      <div className="py-3">
        <div className="d-flex align-items-center">
          <span
            className="rv-primary-background-color p-1 rounded-circle d-flex align-items-center justify-content-center"
            style={{ width: "32px", height: "32px" }}
          >
            <i class="ri-information-line rv-text-primary-color"></i>
          </span>
          <div className="px-2">
            <h4 class="mb-0 fs-14 fw-semibold text-black">
              {offer.description}
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelfcareOfferCard;
